"use client";
import "@fortawesome/fontawesome-svg-core/styles.css";
import {
  faBus,
  faCar,
  faPersonBiking,
  faPersonWalking,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAtom } from "jotai";
import { useEffect } from "react";
import { Form } from "react-bootstrap";
import { useErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import GoogleAPI from "services/GoogleService";
import { filtersAtomObject, filtersCommuteAtomObject } from "../../state";
import ObjectChecker from "../../utils/ObjectChecker";
import CommuteFilterPlaces from "components/Filters/CommuteFilterPlaces";

const CommuteFilter = () => {
  const [filters, setFilters] = useAtom(filtersAtomObject);
  const [commuteFilters, setCommuteFilters] =  useAtom(filtersCommuteAtomObject)
 
  const { showBoundary } = useErrorBoundary();

  const { t } = useTranslation();

  const handleChange = ({ key, id, name }) => {
    setCommuteFilters({
      ...commuteFilters,
      [key]: {
        id: id,
        name: name,
      },
    });
  };

  const getLatLon = async ({ address, method, duration }) => {
    console.log(address, method, duration);

    let response;

    try {
      response = await GoogleAPI.encode(address);
    } catch (err) {
      showBoundary(err);
    }

    if (response.status !== "OK") {
      return;
    }

    const name = response.results[0]?.formatted_address;
    const latlng = response.results[0]?.geometry.location;

    setFilters({
      ...filters,
      commute: {
        travelTime: duration,
        startingLocation: {
          latlng,
          name,
        },
        method,
      },
    });
  };

  useEffect(() => {
    const { commuteLocation, commuteMethod, commuteTime } = commuteFilters;

    if (commuteLocation && commuteMethod && commuteTime) {
      getLatLon({
        address: commuteLocation.name,
        method: commuteMethod,
        duration: commuteTime.id,
      });
    }
  }, [commuteFilters.commuteLocation, commuteFilters.commuteMethod, commuteFilters.commuteTime]);


  useEffect(() => {
    if (new ObjectChecker().IsEmpty(filters.commute)) {
      setCommuteFilters({});
    }

  }, [filters.commute])

  const handleLocationSelect = (address) => {
    if (address.trim() === "") return;

    setCommuteFilters({
      ...commuteFilters,
      commuteLocation: {
        name: address,
      },
      commuteSearchTerm: {
        name: address,
      },
    });

  };

  return (
    <>
      <div className="filters">
        <div className="filter">
          <div className="element button-icons">
            <Form.Label>{t("travel_by")}</Form.Label>
            <div className="field">
              <button
                className={commuteFilters.commuteMethod?.id === 3 ? "selected" : ""}
                type="button"
                aria-label="walking"
                id="commuteMethodWalking"
                onClick={() =>
                  handleChange({ key: "commuteMethod", id: 3, name: "walking" })
                }
              >
                <FontAwesomeIcon icon={faPersonWalking} />
                <span>{t("walk")}</span>
              </button>
              <button
                className={commuteFilters.commuteMethod?.id === 4 ? "selected" : ""}
                type="button"
                aria-label="biking"
                id="commuteMethodBiking"
                onClick={() =>
                  handleChange({ key: "commuteMethod", id: 4, name: "bike" })
                }
              >
                <FontAwesomeIcon icon={faPersonBiking} />
                <span>{t("bike")}</span>
              </button>
              <button
                className={commuteFilters.commuteMethod?.id === 1 ? "selected" : ""}
                type="button"
                aria-label="car"
                id="commuteMethodCar"
                onClick={() => {
                  handleChange({
                    key: "commuteMethod",
                    id: 1,
                    name: "driving",
                  });
                }}
              >
                <FontAwesomeIcon icon={faCar} />
                <span>{t("car")}</span>
              </button>
              <button
                className={commuteFilters.commuteMethod?.id === 5 ? "selected" : ""}
                type="button"
                aria-label="public"
                id="commuteMethodPublic"
                onClick={() =>
                  handleChange({
                    key: "commuteMethod",
                    id: 5,
                    name: "public transport",
                  })
                }
              >
                <FontAwesomeIcon icon={faBus} />
                <span>{t("public")}</span>
              </button>
            </div>
          </div>
        </div>

        {commuteFilters.commuteMethod && (
          <CommuteFilterPlaces
          commuteFilters={commuteFilters}
          handleLocationSelect={handleLocationSelect}
          handleChange={handleChange}
          ></CommuteFilterPlaces>
        )}

        {commuteFilters.commuteMethod && commuteFilters.commuteLocation && (
          <div className="filter">
            <div className="element button-icons text">
              <Form.Label>{t("within")}</Form.Label>
              <div className="field">
                <button
                  value="15"
                  className={commuteFilters.commuteTime?.id === 15 ? "selected" : ""}
                  type="button"
                  aria-label=""
                  id="commuteTime15"
                  onClick={() =>
                    handleChange({ key: "commuteTime", id: 15, name: null })
                  }
                >
                  <span>
                    <strong>15</strong> <span>{t("mins")}</span>
                  </span>
                </button>

                <button
                  value="30"
                  className={commuteFilters.commuteTime?.id === 30 ? "selected" : ""}
                  type="button"
                  aria-label=""
                  id="commuteTime30"
                  onClick={() =>
                    handleChange({ key: "commuteTime", id: 30, name: null })
                  }
                >
                  <span>
                    <strong>30</strong> <span>{t("mins")}</span>
                  </span>
                </button>
                <button
                  value="45"
                  className={commuteFilters.commuteTime?.id === 45 ? "selected" : ""}
                  type="button"
                  aria-label=""
                  id="commuteTime30"
                  onClick={() =>
                    handleChange({ key: "commuteTime", id: 45, name: null })
                  }
                >
                  <span>
                    <strong>45</strong> <span>{t("mins")}</span>
                  </span>
                </button>
                <button
                  value="60"
                  className={commuteFilters.commuteTime?.id === 60 ? "selected" : ""}
                  type="button"
                  aria-label=""
                  id="commuteTime60"
                  onClick={() =>
                    handleChange({ key: "commuteTime", id: 60, name: null })
                  }
                >
                  <span>
                    <strong>60</strong> <span>{t("mins")}</span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CommuteFilter;
